import React, { useState, useCallback, useEffect,useContext } from 'react'
import './AgentWindow.css';
import AlertContext from '../../../context/AlertModelContext/AlertModalContext'
import { useTranslation } from "react-i18next";
import { MdPhoneCallback, MdPhoneDisabled, MdHeadsetMic, MdHeadsetOff } from "react-icons/md";
import { FormControl, Select, MenuItem, Divider } from '@mui/material';


//                     breakName={this.props.breakName}
//                     breakDurationSec={this.props.breakDurationSec}
//                     breakStartTime={this.props.breakStartTime}
//                     acdState={this.props.acdState}
//                     breakReasons={this.props.breakReasons}
//                     OnBreakStateBtnClicked={this.handleOnBreakStateBtnClicked}
//                     OnAcdBtnClicked={this.handleOnAcdBtnClicked}
//                     handleOndialerStateBtnClicked={this.handleOndialerStateBtnClicked}

const AgentWindow = (props) => {
    //@@@@@@@@@@useStates@@@@@@@@@@
    const alertCtx = useContext(AlertContext)
    const [t] = useTranslation('common')
    let initSelectedBreakState = t('Select break')
    const [selectedBreakState, setSelectedBreakState] = useState(initSelectedBreakState)

    const OnAcdBtnClicked = props.OnAcdBtnClicked
    const acdState = props.acdState
    const breakName = props.breakName
    const OnBreakStateBtnClicked = props.OnBreakStateBtnClicked

    //@@@@@@@@@@useCallback@@@@@@@@@@

    const handleBreakSelectChange = useCallback((event) => {
        const value = event.target.value
        if (value === 'stop-break') {
            OnBreakStateBtnClicked('stop', selectedBreakState)
        } else if (value && value !== initSelectedBreakState) {
            setSelectedBreakState(value)
            OnBreakStateBtnClicked('start', value)
        }
    }, [setSelectedBreakState, OnBreakStateBtnClicked, selectedBreakState, initSelectedBreakState])
    const handleOnAcdBtnClicked = useCallback(() => {
        if (acdState === 'notConnected') {
            alertCtx.showAlert(t('error'), t('Please connect the extension to the queue'), 'sm')
            return 
        }
        else if (acdState === 'Available') {
            OnAcdBtnClicked('Unavailable')//Sign-Out
        }
        else {
            if (breakName) {
                OnBreakStateBtnClicked('stop', selectedBreakState)
            }
            else {
                OnAcdBtnClicked('Available')
            }
        }
    }, [OnAcdBtnClicked, acdState , OnBreakStateBtnClicked,breakName,selectedBreakState,alertCtx])

    
    const handleOnBreakStateBtnClicked = useCallback(() => {
        if (!breakName) {//start a break
            if (selectedBreakState === initSelectedBreakState) return alertCtx.showAlert(t('error'), t('Select the type of break'), 'sm')
            OnBreakStateBtnClicked('start', selectedBreakState)
        }
        else {//stop a break
            OnBreakStateBtnClicked('stop', selectedBreakState)
        }
    }, [breakName, initSelectedBreakState, OnBreakStateBtnClicked, selectedBreakState,alertCtx])

    useEffect(() => {
        if (!breakName) {
            setSelectedBreakState(initSelectedBreakState)
        }
        else {
            setSelectedBreakState(breakName)
        }

    }, [breakName, initSelectedBreakState])

    //@@@@@@@@@@function@@@@@@@@@@


    // Build MUI Select menu items
    let breakMenuItems = []
    // Add "Stop Break" option at the top when break is active
    if (breakName) {
        breakMenuItems.push(
            <MenuItem key="stop-break" value="stop-break" sx={{ direction: 'ltr', textAlign: 'right', color: '#dc3545', fontWeight: 600 }}>
                {t('Stop break')}
            </MenuItem>
        )
        breakMenuItems.push(<Divider key="divider" />)
    }
    // Add break reasons
    if (props.breakReasons) {
        props.breakReasons.forEach((breakItem, i) => {
            breakMenuItems.push(
                <MenuItem key={i} value={breakItem.breakName} sx={{ direction: 'ltr', textAlign: 'right' }}>
                    {breakItem.breakName}
                </MenuItem>
            )
        })
    }
    //AgentQueueDiv
    let AgentQueueDiv = 'AgentQueueDiv'
    let AgentQueueTitle = t('Not in queue')
    if (acdState === 'Available') {
        AgentQueueDiv += ' toGreenColor'
        AgentQueueTitle = t('Available')
    }
    else if (acdState === 'notConnected') {
        AgentQueueDiv += ' toBlackColor'
        AgentQueueTitle = t('Not in queue')
    }
    else {
        AgentQueueDiv += ' toRedColor'
        AgentQueueTitle = t('Unavailable')
    }

    //callsCount
    const callsCount = t('Today calls count',{todayCallsCount:props.todayCallsCount})

    //breakIcon
    let AgentQueueButton = undefined
    if (!breakName) {
        AgentQueueButton = 'far fa-play-circle breakButton'
    }
    else {
        AgentQueueButton = 'far fa-pause-circle breakButton'
    }

    //break seconds timer
    let breakDurationSec = undefined
    let timerSeconds = undefined
    let timerText = undefined
    if (!props.breakName) {
        breakDurationSec = 0
        timerText = 'timerText timerTextNotVisibale'
    }
    else {
        breakDurationSec = parseInt(props.breakDurationSec, 10)
        timerSeconds = new Date(breakDurationSec * 1000).toISOString().substr(11, 8);
        timerText = 'timerText'
    }

    //isDialerActive
    const isDialerActive = props.isDialerActive
    const changeAgentDialerState = props.OnchangeAgentDialerState

    let DialerButtonDiv = 'DialerButtonDiv'
    let DialerButtonTitle = t('Callbacks inactive')
    if (isDialerActive) {
        DialerButtonDiv += ' toGreenColor'
        DialerButtonTitle = t('Callbacks active')
    }
    else {
        DialerButtonDiv += ' toRedColor'
    }
    const handleOnChangeAgentDialerStateBtnClicked = useCallback(() => {
        changeAgentDialerState()
    }, [changeAgentDialerState])

    const PbxConnectionStatus = props.PbxConnectionStatus
    let HebPbxConnectionStatus = undefined
    let PbxConnectionStatusDiv = 'PbxConnectionStatusDiv'  //PbxConnectionStatusBtnNotVisibale
    let PbxConnectionStatusButton = 'fas fa-sync-alt PbxConnectionStatusButton'
    if (PbxConnectionStatus === 'connected') {//connected,notConnected,connecting
        HebPbxConnectionStatus = t('Connected to the PBX')
        PbxConnectionStatusDiv += ' toGreenColor'
        PbxConnectionStatusButton += ' PbxConnectionStatusBtnNotVisibale'
    }
    else if (PbxConnectionStatus === 'notConnected') {
        HebPbxConnectionStatus = t('Not connected to the PBX')
        PbxConnectionStatusDiv += ' toRedColor'
    }
    else if (PbxConnectionStatus === 'connecting') {
        HebPbxConnectionStatus = t('Connecting to the PBX')
        PbxConnectionStatusDiv += ' toOrangeColor'
        PbxConnectionStatusButton += ' PbxConnectionStatusBtnNotVisibale'
    }
    if (props.device) HebPbxConnectionStatus = `(${props.deviceShortNum} - ${props.device}) ${HebPbxConnectionStatus}`


    return (
        <div className="agentWindowContainer">
            <div className="row">
                <div className="col-sm-12 col-md-2"></div>
                <div className="col-sm-12 col-md-8">
                    <div className="agentToolbar">
                        
                        <div className="BreaksDiv">
                            {/* <p className={timerText}>{timerSeconds}</p> */}
                            {/* <i className={AgentQueueButton} onClick={handleOnBreakStateBtnClicked}></i> */}
                            <FormControl size="small" sx={{ minWidth: 200 }}>
                                <Select
                                    value={breakName ? breakName : selectedBreakState}
                                    onChange={handleBreakSelectChange}
                                    displayEmpty
                                    renderValue={(selected) => {
                                        if (breakName && timerSeconds) {
                                            return `${breakName} (${timerSeconds})`
                                        }
                                        if (breakName) {
                                            return breakName
                                        }
                                        return selected
                                    }}
                                    sx={{
                                        height: 36,
                                        fontSize: '14px',
                                        fontWeight: breakName ? 600 : 400,
                                        backgroundColor: breakName ? '#fff3cd' : '#fff',
                                        border: breakName ? '2px solid #ffc107' : '1px solid #6c757d',
                                        borderRadius: '20px',
                                        color: breakName ? '#856404' : 'inherit',
                                        '& .MuiOutlinedInput-notchedOutline': {
                                            border: 'none',
                                        },
                                        '& .MuiSelect-icon': {
                                            color: breakName ? '#856404' : 'inherit',
                                        },
                                        '&:hover': {
                                            borderColor: breakName ? '#d39e00' : '#495057',
                                            backgroundColor: breakName ? '#ffe8a1' : '#f8f9fa',
                                        }
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            sx: {
                                                maxHeight: 300,
                                                borderRadius: '12px',
                                                marginTop: '4px',
                                            }
                                        }
                                    }}
                                >
                                    {!breakName && (
                                        <MenuItem value={initSelectedBreakState} disabled sx={{ direction: 'ltr', textAlign: 'right' }}>
                                            {initSelectedBreakState}
                                        </MenuItem>
                                    )}
                                    {breakMenuItems}
                                </Select>
                            </FormControl>
                        </div>
                        <div className={DialerButtonDiv} onClick={handleOnChangeAgentDialerStateBtnClicked}>
                            {isDialerActive ?
                                <MdPhoneCallback className="DialerButtonIcon" /> :
                                <MdPhoneDisabled className="DialerButtonIcon" />
                            }
                            <p className="DialerButtonTitle">{DialerButtonTitle}</p>
                        </div>
                        <div className={AgentQueueDiv} onClick={handleOnAcdBtnClicked}>
                            {acdState === 'Available' ?
                                <MdHeadsetMic className="AgentQueueButton" /> :
                                <MdHeadsetOff className="AgentQueueButton" />
                            }
                            <p className="AgentQueueTitle">{AgentQueueTitle}</p>
                        </div>
                        <div className="toolbarSeparator"></div>
                        <p className="callsCount">{callsCount}</p>
                        
                        <div className={PbxConnectionStatusDiv}>
                            <p className='PbxConnectionStatusTitle'>{HebPbxConnectionStatus}</p>
                            <i className={PbxConnectionStatusButton} onClick={props.OnDialerReConnectBtnClicked}></i>
                        </div>
                    </div>
                </div>
                <div className="col-sm-12 col-md-2"></div>
            </div>
        </div>
    )
}

export default AgentWindow